export const FETCH = 'FETCH';
export const CREATE = 'CREATE';
export const DELETE = 'DELETE';
export const LIKE = 'LIKE';
export const UPDATE = 'UPDATE';
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const SIGNIN = 'SIGNIN';
export const SIGNUP = 'SIGNUP';